<template>
  <div class="flex justify-center w-full h-full flex-col items-center gap-y-2">
    <img
      src="@/app/ui/assets/svg/ill_spot_search.svg"
      alt="not-data-filter"
      width="160"
      height="135"
    />
    <div class="text-sm text-black-lp-300 font-semibold">
      No. STT/DEM tidak ditemukan
    </div>
    <div class="text-sm text-gray-lp-600">
      Cek kembali atau cari nomor STT/DEM lain.
    </div>
  </div>
</template>
